export var _TextProcessingMode;
(function (_TextProcessingMode) {
    _TextProcessingMode[_TextProcessingMode["textExtraction"] = 0] = "textExtraction";
    _TextProcessingMode[_TextProcessingMode["textLayOut"] = 1] = "textLayOut";
    _TextProcessingMode[_TextProcessingMode["redaction"] = 2] = "redaction";
    _TextProcessingMode[_TextProcessingMode["textLineExtraction"] = 3] = "textLineExtraction";
    _TextProcessingMode[_TextProcessingMode["imageExtraction"] = 4] = "imageExtraction";
    _TextProcessingMode[_TextProcessingMode["imageRedaction"] = 5] = "imageRedaction";
})(_TextProcessingMode || (_TextProcessingMode = {}));
/**
 * Public enum for PDF image format.
 * ```typescript
 * // Load an existing PDF document
 * let document: PdfDocument = new PdfDocument(data);
 * // Initialize a new instance of the `PdfDataExtractor` class
 * let extractor: PdfDataExtractor = new PdfDataExtractor(document);
 * // Extract collection of `PdfEmbeddedImage` from the PDF document.
 * let imageInfoCollection: PdfEmbeddedImage[] = extractor.extractImages({ startPageIndex: 0, endPageIndex: document.pageCount - 1});
 * Gets the image format.
 * let imageInfo: PdfEmbeddedImage = imageInfoCollection[0];
 * let imageFormat: ImageFormat = imageInfo.ImageFormat;
 * // Destroy the documents
 * document.destroy();
 * ```
 */
export var ImageFormat;
(function (ImageFormat) {
    /**
     * Gets the W3C Portable Network Graphics (PNG) image format.
     */
    ImageFormat[ImageFormat["png"] = 0] = "png";
    /**
     * Gets the Joint Photographic Experts Group (JPEG) image format.
     */
    ImageFormat[ImageFormat["jpeg"] = 1] = "jpeg";
    /**
     * Specifies the unknown image type.
     */
    ImageFormat[ImageFormat["unknown"] = 2] = "unknown";
})(ImageFormat || (ImageFormat = {}));
